import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Input, Popconfirm, Row, Switch } from "antd";
import { useState } from "react";
import { useList } from "react-use";
import "./Package.scss";

const Package: React.FC = () => {
  const [packageList, { push, updateAt, removeAt }] = useList<Package>(
    []
  );
  const [keyEditCard, setKeyEditCard] = useState(-1);
  const [openModal, setOpenModal] = useState(false);
  const onHandleEditCard = (key: number) => {
    setKeyEditCard(key);
  };
  const onHandleSaveCard = (key: number) => {
    setKeyEditCard(-1);
  };

  const openModalAddNew = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <div className="setting_package">
      <div className="add_package_btn">
        <Button
          type="default"
          className="btn_add_package"
          onClick={openModalAddNew}
          size="large"
          icon={<PlusCircleOutlined />}
        >
          Add Package
        </Button>
      </div>
      <div className="list_package">
        <Row className="space_tag" gutter={[6, 6]}>
          {packageList.map((pack, idx) => (
            <Col span={24} md={12} lg={8} key={idx}>
              <Card
                className="card_style"
                style={{ width: "100%" }}
                title={pack.packageName}
                actions={[
                  <Popconfirm
                    placement="topLeft"
                    title={"Bạn có chắc xóa Package này?"}
                    onConfirm={() => {
                      removeAt(idx);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteOutlined
                      key="delete"
                      className="delete_btn"
                      style={{ color: "red" }}
                    />
                  </Popconfirm>,
                  <EditOutlined
                    key="edit"
                    className="edit_btn"
                    onClick={() => onHandleEditCard(idx)}
                    style={{ color: "gray" }}
                  />,
                  <SaveOutlined
                    onClick={() => onHandleSaveCard(-1)}
                    style={{ color: "green" }}
                  />,
                ]}
              >
                <div className="content">
                  <div className="content-line">
                    <span>Báo cáo kinh doanh</span>{" "}
                    <Switch
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                      checked={pack.financialReport}
                      disabled={keyEditCard !== idx}
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          financialReport: e,
                        });
                      }}
                    />
                  </div>
                  <div className="content-line">
                    <span>Phân quyền nhân viên</span>{" "}
                    <Switch
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                      checked={pack.employeeAuthorization}
                      disabled={keyEditCard !== idx}
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          employeeAuthorization: e,
                        });
                      }}
                    />
                  </div>
                  <div className="content-line">
                    <span>Thanh toán online</span>{" "}
                    <Switch
                      checkedChildren="ON"
                      unCheckedChildren="OFF"
                      checked={pack.onlinePayment}
                      disabled={keyEditCard !== idx}
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          onlinePayment: e,
                        });
                      }}
                    />
                  </div>
                  <div className="content-line">
                    <span>Mức phí hàng tháng</span>{" "}
                    <Input
                      disabled={keyEditCard !== idx}
                      value={pack.monthlyFee}
                      type="number"
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          monthlyFee: +e.target.value || 0,
                        });
                      }}
                    />
                  </div>
                  <div className="content-line">
                    <span>Mức phí theo năm</span>{" "}
                    <Input
                      value={pack.annualFee}
                      type="number"
                      disabled={keyEditCard !== idx}
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          annualFee: +e.target.value || 0,
                        });
                      }}
                    />
                  </div>
                  <div className="content-line">
                    <span>Khuyến mãi (%)</span>{" "}
                    <Input
                      disabled={keyEditCard !== idx}
                      value={pack.promotion}
                      type="number"
                      onChange={(e) => {
                        updateAt(idx, {
                          ...packageList[idx],
                          monthlyFee: +e.target.value || 0,
                        });
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};
export default Package;
